import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  opacity: ${({ isActive = true }) => (isActive ? 1 : 0.2)};
  color: #97a0c0;
  text-transform: capitalize;
  margin: 3px 5px;
`;
